import { render, staticRenderFns } from "./API.vue?vue&type=template&id=07f405e2&scoped=true&"
import script from "./API.vue?vue&type=script&lang=js&"
export * from "./API.vue?vue&type=script&lang=js&"
import style0 from "./API.vue?vue&type=style&index=0&id=07f405e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f405e2",
  null
  
)

export default component.exports